var AdminreportingController = (function () {
    function AdminreportingController($state, settings, env, socket, $scope, Dialog, admin, notify) {
        var _this = this;
        this.$state = $state;
        this.settings = settings;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.admin = admin;
        this.notify = notify;
        this.tables = ['Merger'];
        this.isSaving = false;
        this.selectedTable = 0;
        this.dataLoaded = false;
        this.socket.forward('admin.reporting.query', this.$scope);
        this.$scope.$on('socket:admin.reporting.query', function (event, data) {
            _this.dataLoaded = true;
            if (data.error) {
                return _this.notify.error("Unable to load table data => " + data.error);
            }
            _this.data = data.data;
        });
    }
    AdminreportingController.prototype.$onInit = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {
                    table: this.selectedTable
                },
                function: 'getReportingData',
                script: 'admin/calculationtables',
                token: this.env.user.token
            }
        });
    };
    AdminreportingController.prototype.switchTable = function () {
        this.dataLoaded = false;
        this.data = undefined;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {
                    table: this.selectedTable
                },
                function: 'getReportingData',
                script: 'admin/calculationtables',
                token: this.env.user.token
            }
        });
    };
    AdminreportingController.$inject = ['$state', 'settings', 'env', 'socket', '$scope', 'Dialog', 'admin', 'notify'];
    return AdminreportingController;
}());
var AdminreportingComponent = (function () {
    function AdminreportingComponent() {
        this.templateUrl = 'adminreporting-view.html';
        this.controllerAs = 'vm';
        this.controller = AdminreportingController;
    }
    return AdminreportingComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider
        .icon('delete', '/public/icons/delete-forever.svg')
        .icon('invalid', '/public/icons/ic_highlight_off_black_24px.svg')
        .icon('save', '/public/images/ic_save_black_24px.svg');
})
    .component('viewAdminreportingSection', new AdminreportingComponent());

//# sourceMappingURL=adminreporting.view.component.js.map
